import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  binLocationListAction,
  storeIdAction,
} from "../../../redux/actions/general-action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  goodsEditAction,
  goodsReceiptCreateAction,
  goodsTempProVeriAction,
} from "../../../redux/actions/purchase-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import BulkGrnModal from "../modals/bulk-grn-modal";
import Papa from "papaparse";
import SalesPurchaseNavbar from "../../sales-section/sales-purchase-navbar";
import PurchaseItemsSection from "../purchase-items-section";
import PurchaseBatchesPanel from "../purchase-batches-panel";
import SalesPurchaseFooter from "../../sales-section/sales-purchase-footer";
import GrnCsvImport from "./grn-csv-import";
import PurchaseCreditNotePanel from "./purchase-cr-db-notes-panel";

const CreateEditViewGrn = ({
  isClone = false,
  orderDetail = [],
  vendorDetails = [],
  disabled = false,
  type = "",
  page = "",
  setOrderDetail,
  setLoading,
  data,
  payto,
  shipto,
  pageType,
  clickedplus,
  transfer=false,
}) => {
  const [heading, setHeading] = useState([]);
  const formValuesRef = useRef(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const isDispatchingRef = useRef(false);
  const submitScheduledRef = useRef(false);
  const [csvTemLoading, setCsvLoading] = useState(false);
  const rowData = useSelector((state) => state.invoiceRowReducer);
  const searchRef = useRef(null);
  const [binLocationList, setBinLocationList] = useState([]);
  const [reload, setReload] = useState(false);
  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [grnCsvImportOpen, setGrnCsvImportOpen] = useState(false);
  const [creditNotesOpen, setCreditNotesOpen] = useState(false);
  const [tcsTdsAmount, setTcsTdsAmount] = useState("");
  const initialData = {
    sl_no: 1,
    item_name: "",
    item_generic_name: "",
    item_code: "",
    item_hsn: "",
    item_manufacturer_name: "",
    item_uom: "",
    item_batches: "",
    // item_unit_price: 0,
    item_to_be_received: 0,
    quantity: 0,
    item_pack_size: 0,
    item_free_quantity: 0,
    item_discount_amount: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_igst: 0,
    pot_id: null,
    item_price_wiithout_tax: 0,
    item_uom_id: "",
    item_manufacturer_id: "",
    base_ref_id: null,
    base_ref_type: null,
    base_ref_line_id: null,
    base_ref_doc_number: null,
  };
  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    is_inter_state:vendorDetails?.[0]?.gst_type === "Inter"?true:vendorDetails?.[0]?.gst_type === "Intra"?false:null,
    cmr_phone_number: "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    store_id: vendorDetails?.[0]?.store_id || storeId || "",
    customer_invoice_number:
      vendorDetails?.[0]?.customer_invoice_number ?? null,
    remarks: vendorDetails?.[0]?.remarks ?? "",
    cmr_balance: vendorDetails?.[0]?.cmr_balance || 0,
    gort_total_discount: vendorDetails?.[0]?.gort_total_discount ?? 0,
    ...(vendorDetails?.[0]?.gort_id
      ? { gort_id: vendorDetails?.[0]?.gort_id }
      : {}),
    gort_order_date: vendorDetails?.[0]?.update_date && !isClone
      ? moment(vendorDetails?.[0]?.update_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    gort_document_date: vendorDetails?.[0]?.gort_document_date && !isClone
      ? moment(vendorDetails?.[0]?.gort_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    gort_delivery_date: vendorDetails?.[0]?.gort_delivery_date && !isClone
      ? moment(vendorDetails?.[0]?.gort_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    gort_reference_inv_date: vendorDetails?.[0]?.gort_reference_inv_date&& !isClone
      ? moment(vendorDetails?.[0]?.gort_reference_inv_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    cmr_gstin: vendorDetails?.[0]?.cmr_gstin ?? "",
    gort_order_status: vendorDetails?.[0]?.gort_order_status ?? "",
    gort_round_off_value: vendorDetails?.[0]?.gort_round_off_value ?? 0,

    cmr_tcs: "",
    cmr_tds: "",
    gort_tcs_or_tds_percentage_id:
      vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
    gort_tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage ?? 0,
    gort_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
    gort_tcs_or_tds_amount:
      vendorDetails?.[0]?.gort_tcs_or_tds_amount ||
      vendorDetails?.[0]?.tcs_or_tds_amount ||
      0,
    gort_sub_total: vendorDetails?.[0]?.gort_sub_total ?? 0,
    gort_total_amount: vendorDetails?.[0]?.gort_total_amount ?? 0,
    gort_total_gst: vendorDetails?.[0]?.gort_total_gst ?? 0,

    gort_is_invoice_dis_percentage:
      vendorDetails?.[0]?.gort_is_invoice_dis_percentage ?? true,
    gort_invoice_discount: vendorDetails?.[0]?.gort_invoice_discount ?? 0,
    gort_invoice_discount_percentage:
      vendorDetails?.[0]?.gort_invoice_discount_percentage ?? 0,
    gort_pay_to_address: payto, //new
    gort_ship_to_address: shipto, //new
    header_dis_per: "",
    header_inv_dis_per: vendorDetails?.[0]?.gort_is_invoice_dis_percentage
      ? vendorDetails?.[0]?.gort_invoice_discount_percentage
      : vendorDetails?.[0]?.gort_invoice_discount,
    data: [
      ...orderDetail?.map((item, index) => ({
        sl_no: index + 1,
        item_name: item?.item_name,
        item_generic_name: item?.item_generic_name,
        item_code: item?.item_code,
        item_hsn: item?.item_hsn,
        item_manufacturer_name: item?.item_manufacturer_name,
        item_uom: item?.item_uom,
        item_batches:
          item?.itemBatchData?.length > 0
            ? item?.itemBatchData?.map((batch) => ({
                item_batch_number: batch?.item_batch_number,
                item_sellable_quantity: parseFloat(batch?.item_sellable_quantity),
                item_batch_free_quantity:
                  parseFloat(batch?.item_batch_free_quantity) || 0,
                gst_type:vendorDetails?.[0]?.gst_type,
                item_batch_total_effective_qauntity:
                  parseInt(batch?.item_batch_total_effective_qauntity) || 0, //new

                item_batch_total_base_purchase_rate:
                  parseFloat(batch?.item_batch_total_base_purchase_rate) || 0, //new
                item_batch_ptr_amount:
                  parseFloat(batch?.item_batch_ptr_amount) || 0,
                item_batch_pts:
                  parseFloat(batch?.item_batch_pts_amount) || 0,
                item_batch_for_qauntity:
                  parseInt(batch?.item_batch_for_qauntity) || 0, //new
                item_batch_for_free_qauntity:
                  parseInt(batch?.item_batch_for_free_qauntity) || 0, //new
                item_batch_scheme_discount_percentage:
                  parseFloat(batch?.item_batch_scheme_discount_percentage) || 0, //new
                item_batch_scheme_discount_amount:
                  parseFloat(batch?.item_batch_scheme_discount_amount) || 0, //new

                item_batch_scheme_purchase_rate:
                  parseFloat(batch?.item_batch_scheme_purchase_rate) || 0, //new

                item_batch_discount_percentage:
                  parseFloat(batch?.item_batch_discount_percentage) || 0, //new
                item_batch_gen_discount_amount:
                  parseFloat(batch?.item_batch_gen_discount_amount) || 0, //new
                item_batch_discounted_purchase_rate:
                  parseFloat(batch?.item_batch_discounted_purchase_rate) || 0, //new

                item_batch_purchase_rate:
                  parseFloat(batch?.item_batch_purchase_rate) ?? 0,
                item_batch_discount_amount: parseFloat(
                  batch?.item_batch_discount_amount
                ),
                item_batch_taxable_amount: parseFloat(
                  batch?.item_batch_taxable_amount
                ),
                item_batch_purhcase_rate_before_tax:
                  parseFloat(batch?.item_batch_purhcase_rate_before_tax) ||
                  parseFloat(batch?.item_batch_purchase_rate) ||
                  0,
                item_batch_total_purchase_rate: parseFloat(
                  batch?.item_batch_total_purchase_rate
                ),
                item_batch_tax_percentage: parseFloat(
                  batch?.item_batch_tax_percentage
                ),
                item_batch_tax_amount: parseFloat(batch?.item_batch_tax_amount),
                item_batch_final_purchase_rate: parseFloat(
                  batch?.item_batch_final_purchase_rate
                ),
                item_batch_total_purchase_rate: parseFloat(
                  batch?.item_batch_total_purchase_rate
                ),
                item_batch_cgst_percentage:batch?.item_batch_cgst_percentage,
                item_batch_sgst_percentage:batch?.item_batch_sgst_percentage,
                item_batch_igst_percentage:batch?.item_batch_igst_percentage,
                item_batch_cgst_amount:batch?.item_batch_cgst_amount,
                item_batch_sgst_amount:batch?.item_batch_sgst_amount,
                item_batch_igst_amount:batch?.item_batch_igst_amount,
                item_batch_unit_price:
                  parseFloat(batch?.item_batch_unit_price) ?? 0,
                item_batch_margin_percentage:
                  parseFloat(batch?.item_batch_margin_percentage) ?? 0,
                item_exp_date: batch?.item_exp_date,
                item_id: batch?.item_id,
                from_bin_location: batch?.from_bin_location,
                to_bin_location: batch?.to_bin_location,
                from_bin_id: batch?.from_bin_id,
                to_bin_id: batch?.to_bin_id,
                item_uom: orderDetail?.[0]?.item_uom,
                item_uom_id: orderDetail?.[0]?.item_uom_id,
              }))
            : [],
        // item_unit_price: item?.item_unit_price,
        // item_price_wiithout_tax: 0,
        item_return_open_quantity:
          type === "return"
            ? item?.item_credit_quanity_remaining ??
              item?.item_to_be_received ??
              item?.item_invoice_open_quantity ??
              0
            : item?.item_to_be_received ??
              item?.item_invoice_open_quantity ??
              item?.item_credit_quanity_remaining ??
              0,
        item_to_be_received:
          item?.item_to_be_received ??
          item?.item_invoice_open_quantity ??
          item?.item_credit_quanity_remaining ??
          0,
        item_invoice_open_quantity:
          item?.item_invoice_open_quantity ??
          item?.item_to_be_received ??
          item?.item_credit_quanity_remaining ??
          0,
        quantity: item?.item_quantity ?? 0,
        item_pack_size: item?.item_pack_size || 0,
        base_quantity: item?.base_quantity || 0,
        // page === "view" || page === "edit" || type === "return"
        //   ? item?.item_quantity
        //   : 0,
        item_free_quantity: parseFloat(item?.item_free_quantity) || 0,

        item_discount_amount: parseFloat(item?.item_discount_amount) || 0,
        // page === "view" || page === "edit" || type === "return"
        //   ? parseFloat(item?.item_discount_amount)
        //   : 0,
        item_tax_amount: parseFloat(item?.item_tax_amount) || 0,
        // page === "view" || page === "edit" || type === "return"
        //   ? parseFloat(item?.item_tax_amount)
        //   : 0,
        item_total_amount: item?.item_total_amount || 0,
        // page === "view" || page === "edit" || type === "return"
        //   ? item?.item_total_amount
        //   : 0,
        item_id: item?.item_id,
        pot_id: item?.pot_id || null,
        prt_id: item?.prt_id || null,
        base_ref_id: item?.pot_id ?? item?.prt_id ?? null,
        base_ref_type: item?.ref_type ?? null,
        base_ref_line_id: item?.item_id ?? null,
        base_ref_doc_number: item?.ref_doc_number ?? null,
        item_gst: parseFloat(item?.item_gst || 0),
        item_sgst: parseFloat(item?.item_sgst || 0),
        item_cgst: parseFloat(item?.item_cgst || 0),
        item_igst: parseFloat(item?.item_igst || 0),
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
              base_quantity: uom?.base_quantity ?? 1,
            }))
          : [],
        item_uom_id: item?.item_uom_id || "",
        item_manufacturer_id: item?.item_manufacturer_id || "",
      })),
      initialData,
    ],
    vendorTemplate: [],
    creditNoteData: (data?.creditNoteData || []).map((note) => ({
      invoice_number: note?.invoice_number ?? "",
      invoice_total_amount: parseFloat(note?.invoice_total_amount) || 0,
      remaining_amount: parseFloat(note?.remaining_amount) || 0,
      adjusted_amount: parseFloat(note?.adjusted_amount) || 0,
      claimed_amount: parseFloat(note?.claimed_amount) || 0,
      invoice_date: note?.invoice_date ?? "",
      remarks: note?.remarks ?? "",
    })),
    claimed_adjusted: vendorDetails?.[0]?.claimed_adjusted ?? "0.00",
    ledger_closing: vendorDetails?.[0]?.ledger_closing ?? "0.00",
    pcn_net_balance: vendorDetails?.[0]?.pcn_net_balance ?? "0.00",
    pcns_total: vendorDetails?.[0]?.pcns_total ?? "0.00",
    remaining_balance: vendorDetails?.[0]?.remaining_balance ?? "0.00",
  };
  const [initialValue, setInitialValue] = useState(initialFormValues);
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Vendor code is required"),
    cmr_name: Yup.object().required("Vendor name is required"),
    data: Yup.array().of(
      Yup.object().shape({
        item_batches: Yup.array().of(
          Yup.object().shape({
            item_batch_purchase_rate: Yup.number()
              .typeError("Must be a number")
              .required("Purchase rate is required")
              .moreThan(0, "Purchase rate must be greater than 0"),

            item_batch_unit_price: Yup.number()
              .typeError("Must be a number")
              .required("MRP is required")
              .moreThan(0, "MRP must be greater than 0")
              .test(
                "MRP-greater-than-final-purchase-rate",
                "MRP must be greater than the final purchase rate",
                function (value) {
                  const { item_batch_final_purchase_rate } = this?.parent;
                  return value > item_batch_final_purchase_rate;
                }
              ),
            item_sellable_quantity: Yup.number()
              .typeError("Must be a number")
              .required("Sellable quantity is required")
              .moreThan(0, "Sellable quantity must be greater than 0"),
            item_batch_free_quantity: Yup.number()
              .transform((value) =>
                typeof value === "string" ? parseFloat(value) : value
              ) // Transform string to number
              .typeError("Must be a number"),
            item_batch_number: Yup.string().required(
              "Batch number is required"
            ),
            // to_bin_id: Yup.string().required("Bin ID is required"),
            item_exp_date: Yup.date().required("Expiration date is required"),
          })
        ),
      })
    ),
  });
  const fetchStoreDetails = () => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    dispatch(binLocationListAction(onSuccessBin, onerrorBin));
  };

  useEffect(() => {
    fetchStoreDetails();

    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const GRNdata = parsed.find((obj) => obj?.GRN_Create);
      if (GRNdata?.GRN_Create) {
        setHeading(GRNdata.GRN_Create);
      }
    }
  }, []);

  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    const storeData=data?.data;
    const storeState=storeData?.store_state;
    const store_state=storeState?.toLowerCase()?.trim();
    if(store_state===null || store_state===undefined || store_state?.trim()===""){
        errorToast("Please configure store state in store deatils")
        return;
    }
  };
  const onErrorStoreDetails = () => {};
  const onSuccessBin = (data) => {
    setBinLocationList(
      data?.data?.map((item) => ({
        label: (
          <span
            className={`${
              item?.is_expired_bin_location ||
              item?.is_non_sellable_bin_location
                ? "text-F51D00"
                : ""
            }`}
          >
            {item?.bin_location_no}
            {item?.is_expired_bin_location}
            {item?.is_non_sellable_bin_location}
          </span>
        ),
        value: item?.bin_no_id,
        actualLabel: item?.bin_location_no,
      }))
    );
  };
  const onerrorBin = () => {};
// =============================
// FULL handleBilling with NEW VALIDATIONS
// 1) every batch must have all fields (as per payload keys you send)
// 2) sum of batch total amounts == item total amount
// =============================

// ✅ helper (keep in same file, above handleBilling)
const validateBillingItemsAndBatches = (values) => {
  const items = values?.data?.slice(0, -1) || [];
  const isDraft = values?.submittedButton === "draft";

  // drafts are lenient (matches your existing validations pattern)
  // if (isDraft) return true;

  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : NaN;
  };

  const isEmpty = (v) =>
    v === null ||
    v === undefined ||
    (typeof v === "string" && v.trim() === "");

  // Required batch fields based on your itemBatchData mapping in handleBilling
  const REQUIRED_BATCH_FIELDS = [
    "item_batch_number",
    "item_sellable_quantity",
    "item_batch_total_effective_qauntity",
    "item_batch_purchase_rate",
    "item_batch_total_base_purchase_rate",
    "item_batch_gen_discount_amount",
    // "item_batch_taxable_amount",
    "item_batch_purhcase_rate_before_tax",
    "item_batch_total_purchase_rate",
    "item_batch_discount_amount",
    "item_batch_tax_percentage",
    "item_batch_tax_amount",
    "item_batch_final_purchase_rate",
    "item_batch_unit_price",
    "item_exp_date",
    "item_id"
  ];

  const NUMERIC_BATCH_FIELDS = [
    "item_sellable_quantity",
    "item_batch_free_quantity",
    "item_batch_total_effective_qauntity",
    "item_batch_purchase_rate",
    "item_batch_total_base_purchase_rate",
    "item_batch_for_qauntity",
    "item_batch_for_free_qauntity",
    "item_batch_scheme_discount_percentage",
    "item_batch_scheme_discount_amount",
    "item_batch_scheme_purchase_rate",
    "item_batch_discount_percentage",
    "item_batch_gen_discount_amount",
    "item_batch_discounted_purchase_rate",
    "item_batch_taxable_amount",
    "item_batch_purhcase_rate_before_tax",
    "item_batch_total_purchase_rate",
    "item_batch_discount_amount",
    "item_batch_tax_percentage",
    "item_batch_tax_amount",
    "item_batch_final_purchase_rate",
    "item_batch_margin_percentage",
    "item_batch_unit_price",
  ];

  const EPS = 0.01;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const itemLabel = item?.item_name || item?.item_code || `Item ${i + 1}`;

    const batches = item?.item_batches || [];
    if (!Array.isArray(batches) || batches.length === 0) {
      errorToast(`Please add batches for ${itemLabel}`);
      return false;
    }

    // 1) Every batch must have all fields + valid numbers
    for (let b = 0; b < batches.length; b++) {
      const batch = batches[b];

      const missingKeys = REQUIRED_BATCH_FIELDS.filter((k) => isEmpty(batch?.[k]));
      if (missingKeys.length > 0) {
        errorToast(`Please fill all batch fields for ${itemLabel} (Batch ${b + 1})`);
        return false;
      }

      // for (const k of NUMERIC_BATCH_FIELDS) {
      //   const n = toNum(batch?.[k]);
      //   if (!Number.isFinite(n)) {
      //     errorToast(`Invalid ${k} for ${itemLabel} (Batch ${b + 1})`);
      //     return false;
      //   }
      // }
    }

    // 2) Sum of batch total == item total
    // For billing, batch "total" in your payload is item_batch_total_purchase_rate
    const sumBatchTotals = batches.reduce(
      (sum, batch) => sum + (toNum(batch?.item_batch_total_purchase_rate) || 0),
      0
    );

    const itemTotal = toNum(item?.item_total_amount);
    if (!Number.isFinite(itemTotal)) {
      errorToast(`Invalid item total amount for ${itemLabel}`);
      return false;
    }

    if (Math.abs(sumBatchTotals - itemTotal) > EPS) {
      errorToast(
        `Batch total (${sumBatchTotals.toFixed(2)}) must match item total (${itemTotal.toFixed(
          2
        )}) for ${itemLabel}`
      );
      return false;
    }
  }

  return true;
};

// ✅ ENTIRE handleBilling (with validations wired in)
const handleBilling = (values) => {
  // Block duplicate submissions while a request is already in flight.
  if (isDispatchingRef.current) return;
  let actionType = goodsReceiptCreateAction;
  if (page === "edit") {
    actionType = goodsEditAction;
  }
  // console.groupCollapsed(
  //   "%c[handleBilling TRIGGERED]",
  //   "color:#ff0066;font-weight:700;"
  // );

  // console.log("page:", page, "pageType:", pageType, "type:", type);
  // console.log("submittedButton:", values?.submittedButton);
  // console.log("save:", values?.save);
  // console.log("cmr_id:", values?.cmr_id);
  // console.log("items:", values?.data?.length);

  // // ✅ THIS LINE SHOWS EXACTLY FROM WHERE IT WAS CALLED
  // console.trace("handleBilling call stack");

  // console.groupEnd();
  const missingUOM = values?.data?.slice(0, -1).some((item) => !item.item_uom);

  if (
    page === "edit" &&
    values?.submittedButton !== "draft" &&
    values?.gort_order_status !== "draft"
  ) {
    isDispatchingRef.current = true;
    setButtonLoading(true);
    dispatch(
      goodsEditAction(
        {
          orderData: {
            is_draft_order: values.submittedButton === "draft" ? true : false,
            only_remarks: true,
            gort_id: values?.gort_id,
            remarks: values?.remarks,
          },
        },
        (data) => {
          onSuccessOrder(data, values);
        },
        onErrorOrder
      )
    );
  } else {
    if (
      values.data?.slice(0, -1)?.some((item) => item.item_batches.length === 0) &&
      values?.submittedButton !== "draft"
    ) {
      errorToast("Please add batches for all items");
    } else if (
      values?.data
        ?.slice(0, -1)
        .some((item) => parseFloat(item.quantity) === 0 || item.quantity === "") &&
      values?.submittedButton !== "draft"
    ) {
      errorToast("Quantity cannot be zero");
    } else if (missingUOM && values?.submittedButton !== "draft") {
      errorToast("Please add UOM for all items");
    } else {
      if (!values?.gort_pay_to_address) {
        errorToast("Please verify and save the address");
        return;
      }
      if (!values?.gort_ship_to_address) {
        errorToast("Please verify and save the address");
        return;
      }
      // ✅ NEW VALIDATIONS (batch completeness + sum of batch totals == item total)
      if (!validateBillingItemsAndBatches(values)) return;
      if (values?.data?.length > 1) {
        isDispatchingRef.current = true;
        setButtonLoading(true);
        dispatch(
          actionType(
            {
              orderData: {
                is_draft_order: values.submittedButton === "draft" ? true : false,
                store_id: values?.store_id,
                ...(values?.gort_id ? { gort_id: values?.gort_id } : {}),
                gort_total_gst: Number(values?.gort_total_gst) || 0,
                gort_total_discount: Number(values?.gort_total_discount) || 0,
                gort_payment_status: "paid",
                gort_transaction_id: "",
                gort_billing_address: "",
                gort_sub_total: Number(values?.gort_sub_total) || 0,
                gort_total_amount: Number(values?.gort_total_amount) || 0,
                cmr_code: values?.cmr_code?.label,
                cmr_id: values?.cmr_id,
                customer_invoice_number: values?.customer_invoice_number || null,
                cmr_name: values?.cmr_name?.label,
                remarks: values?.remarks,
                gort_order_date: values?.gort_order_date,
                gort_document_date: values?.gort_document_date,
                gort_delivery_date: values?.gort_delivery_date,
                gort_reference_inv_date: values?.gort_reference_inv_date|| null,
                cmr_gstin: values?.cmr_gstin || null,
                gort_round_off_value: Number(values?.gort_round_off_value) || 0,
                gort_tcs_or_tds_percentage_id: values?.gort_tcs_or_tds_percentage_id ?? "",
                gort_tcs_or_tds_percentage: Number(values?.gort_tcs_or_tds_percentage) || 0,
                gort_tds_tcs_type: values?.gort_tds_tcs_type ?? "",
                gort_tcs_or_tds_amount: Number(values?.gort_tcs_or_tds_amount) || 0,
                only_remarks: false,
                gort_is_invoice_dis_percentage: values?.gort_is_invoice_dis_percentage,
                gort_invoice_discount: values?.gort_invoice_discount,
                gort_invoice_discount_percentage: values?.gort_invoice_discount_percentage,
                gort_pay_to_address: values?.gort_pay_to_address || null,
                gort_ship_to_address: values?.gort_ship_to_address || null,
                gst_type:values?.is_inter_state===false?"Intra":"Inter"
              },

              itemData: values?.data?.slice(0, -1).map((item, index) => ({
                item_code: item?.item_code,
                item_id: item?.item_id,
                item_generic_name: item?.item_generic_name,
                item_name: item?.item_name,
                item_hsn: item?.item_hsn,
                ...(values?.gort_id ? { gort_id: values?.gort_id } : {}),
                item_quantity: parseFloat(item?.quantity),
                item_free_quantity: item?.item_free_quantity || 0,
                item_received_quantity: parseFloat(item?.quantity),
                item_total_amount: parseFloat(item.item_total_amount),
                item_pack_size: parseFloat(item.item_pack_size),
                item_tax_amount: item?.item_tax_amount || 0,
                item_discount_amount: item?.item_discount_amount || 0,
                item_gst: item?.item_gst,
                item_cgst: values?.is_inter_state===false?(item?.item_cgst):0,
                item_sgst: values?.is_inter_state===false?(item?.item_sgst):0,
                item_igst: values?.is_inter_state===true?(item?.item_igst):0,
                ...(item?.pot_id ? { pot_id: item?.pot_id } : { pot_id: null }),
                ...(item?.prt_id ? { prt_id: item?.prt_id } : { prt_id: null }),
                base_ref_id: item?.base_ref_id ?? null,
                base_ref_type: item?.base_ref_type ?? null,
                base_ref_line_id: item?.base_ref_line_id ?? null,
                base_ref_doc_number: item?.base_ref_doc_number ?? null,
                item_uom_id: item?.item_uom_id ?? "",
                item_uom: item?.item_uom ?? "",
                item_manufacturer_id: item?.item_manufacturer_id ?? "",
                item_manufacturer_name: item?.item_manufacturer_name ?? "",
              })),

              itemBatchData: values.data?.slice(0, -1).flatMap((item) =>
                item.item_batches.map((batch) => ({
                  item_batch_number: batch?.item_batch_number,
                  ...(values?.gort_id ? { gort_id: values?.gort_id } : {}),
                  item_sellable_quantity: parseFloat(batch?.item_sellable_quantity),
                  item_batch_free_quantity:
                    parseFloat(batch?.item_batch_free_quantity) || 0,
                  item_batch_total_effective_qauntity:
                    parseInt(batch?.item_batch_total_effective_qauntity) || 0,
                  item_batch_purchase_rate: Number(batch?.item_batch_purchase_rate) || 0,
                  item_batch_total_base_purchase_rate:
                    parseFloat(batch?.item_batch_total_base_purchase_rate) || 0,
                  item_batch_for_qauntity: parseInt(batch?.item_batch_for_qauntity) || 0,
                  item_batch_for_free_qauntity: parseInt(batch?.item_batch_for_free_qauntity) || 0,
                  item_batch_scheme_discount_percentage:
                    parseFloat(batch?.item_batch_scheme_discount_percentage) || 0,
                  item_batch_scheme_discount_amount:
                    parseFloat(batch?.item_batch_scheme_discount_amount) || 0,
                  item_batch_scheme_purchase_rate:
                    parseFloat(batch?.item_batch_scheme_purchase_rate) || 0,
                  item_batch_discount_percentage:
                    parseFloat(batch?.item_batch_discount_percentage) || 0,
                  item_batch_gen_discount_amount:
                    parseFloat(batch?.item_batch_gen_discount_amount) || 0,
                  item_batch_discounted_purchase_rate:
                    parseFloat(batch?.item_batch_discounted_purchase_rate) || 0,
                  item_batch_taxable_amount: parseFloat(batch?.item_batch_taxable_amount) || 0,
                  item_batch_purhcase_rate_before_tax:
                    parseFloat(batch?.item_batch_purhcase_rate_before_tax) || 0,
                  item_batch_total_purchase_rate:
                    parseFloat(batch?.item_batch_total_purchase_rate) || 0,
                  item_batch_discount_amount: Number(batch?.item_batch_discount_amount) || 0,
                  item_batch_tax_percentage: Number(batch?.item_batch_tax_percentage) || 0,
                  item_batch_tax_amount: Number(batch?.item_batch_tax_amount) || 0,
                  item_batch_final_purchase_rate: Number(batch?.item_batch_final_purchase_rate) || 0,
                  item_batch_margin_percentage: Number(batch?.item_batch_margin_percentage) || 0,
                  item_batch_unit_price: Number(batch?.item_batch_unit_price) || 0,
                  item_exp_date: batch?.item_exp_date,
                  item_id: batch?.item_id,
                  from_bin_location: batch?.from_bin_location,
                  to_bin_location: batch?.to_bin_location,
                  from_bin_id: batch?.from_bin_id,
                  to_bin_id: batch?.to_bin_id,
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_batch_cgst_percentage:values?.is_inter_state===false?(batch?.item_batch_cgst_percentage||0):0,
                  item_batch_sgst_percentage:values?.is_inter_state===false?(batch?.item_batch_sgst_percentage||0):0,
                  item_batch_igst_percentage:values?.is_inter_state===true?(batch?.item_batch_igst_percentage||0):0,
                  item_batch_cgst_amount:values?.is_inter_state===false?(batch?.item_batch_cgst_amount||0):0,
                  item_batch_sgst_amount:values?.is_inter_state===false?(batch?.item_batch_sgst_amount||0):0,
                  item_batch_igst_amount:values?.is_inter_state===true?(batch?.item_batch_igst_amount||0):0,
                  item_batch_ptr_amount:
                    parseFloat(batch?.item_batch_ptr_amount) || 0,
                  item_batch_pts_amount:
                    parseFloat(batch?.item_batch_pts) || 0,
                }))
              ),

              creditNoteData: (values?.creditNoteData || [])
                .filter((note) => note?.isChecked)
                .map((note) => ({
                  invoice_number: note?.invoice_number ?? "",
                  invoice_total_amount: parseFloat(note?.invoice_total_amount) || 0,
                  remaining_amount: parseFloat(note?.remaining_amount) || 0,
                  adjusted_amount: parseFloat(note?.adjusted_amount) || 0,
                  claimed_amount: parseFloat(note?.claimed_amount) || 0,
                  invoice_date: note?.invoice_date ?? "",
                  remarks: note?.remarks ?? "",
                })),
            },
            (data) => {
              onSuccessOrder(data, values);
            },
            onErrorOrder
          )
        );
      }
    }
  }
};


  const onSuccessOrder = (data, values) => {
    formValuesRef.current = null; // Reset after handling
    isDispatchingRef.current = false;
    setButtonLoading(false);
    if (values?.save !== "auto") {
      navigate("/goods");
    }
    if (formValues?.submittedButton === "print") {
      handlea4Print(
        data?.data?.orderData?.[0].gort_id,
        "goods_receipt_note",
        dispatch
      );
    }
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      remarks: "",
      gort_total_discount: 0,
      gort_order_date: null,
      gort_document_date: null,
      gort_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = (data) => {
    isDispatchingRef.current = false;
    setButtonLoading(false);
    errorToast(data?.data?.message);
  };
  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  const handleFileUpload = (event, values) => {
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = null; // This resets the file input
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const parsedData = results.data;
        if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
          errorToast(
            "Error: The CSV file is empty or contains no valid records."
          );
          return; // Stop further processing
        }
        setCsvLoading(true);
        dispatch(
          goodsTempProVeriAction(
            {
              cmr_id: values?.cmr_id,
              cmr_vendor_name: values?.cmr_name?.label,
              itemData: parsedData,
            },
            onSuccess,
            onError
          )
        );
      },
      error: (error) => {
        errorToast("Error parsing file:", error);
      },
    });
  };

  const onSuccess = (data) => {
    navigate("/goods-receipt-csv", {
      state: {
        data: data.data,
        type: "grn", // Add your custom type here
      },
    });

    setCsvLoading(false);
  };
  const onError = (data) => {
    setCsvLoading(false);
    errorToast(data?.data?.message);
  };

  const autoDraft = (values) => {
    if (isDispatchingRef.current) return;
    let actionType = goodsReceiptCreateAction;
    console.log(
      ".................................................................................................."
    );
    if (page === "edit") {
      actionType = goodsEditAction;
    }
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.gort_order_status !== "draft"
    ) {
      isDispatchingRef.current = true;
      setButtonLoading(true);
      dispatch(
        goodsEditAction(
          {
            orderData: {
              is_draft_order: true,
              only_remarks: true,
              gort_id: values?.gort_id,
              remarks: values?.remarks,
            },
          },
          (data) => {
            onSuccessOrder(data, values);
          },
          onErrorOrder
        )
      );
    } else {
      if (
        values.data
          ?.slice(0, -1)
          ?.some((item) => item.item_batches.length === 0) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Please add batches for all items");
      } else if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseFloat(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if (values?.data?.length > 1) {
          isDispatchingRef.current = true;
          setButtonLoading(true);
          dispatch(
            actionType(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: values?.store_id,
                  ...(values?.gort_id ? { gort_id: values?.gort_id } : {}),
                  gort_total_gst: Number(values?.gort_total_gst) || 0,
                  gort_total_discount: Number(values?.gort_total_discount) || 0,
                  gort_payment_status: "paid",
                  gort_transaction_id: "",
                  gort_billing_address: "",
                  gort_sub_total: Number(values?.gort_sub_total) || 0,
                  gort_total_amount: Number(values?.gort_total_amount) || 0,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  customer_invoice_number:
                    values?.customer_invoice_number || null,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  gort_order_date: values?.gort_order_date,
                  gort_document_date: values?.gort_document_date,
                  gort_delivery_date: values?.gort_delivery_date,
                  gort_reference_inv_date: values?.gort_reference_inv_date|| null,
                  cmr_gstin: values?.cmr_gstin || null,
                  gort_round_off_value: Number(values?.gort_round_off_value) || 0,
                  gort_tcs_or_tds_percentage_id:
                    values?.gort_tcs_or_tds_percentage_id ?? "",
                  gort_tcs_or_tds_percentage:
                    Number(values?.gort_tcs_or_tds_percentage) || 0,
                  gort_tds_tcs_type: values?.gort_tds_tcs_type ?? "",
                  gort_tcs_or_tds_amount: Number(values?.gort_tcs_or_tds_amount) || 0,
                  only_remarks: false,
                  gort_is_invoice_dis_percentage:
                    values?.gort_is_invoice_dis_percentage,
                  gort_invoice_discount: values?.gort_invoice_discount,
                  gort_invoice_discount_percentage:
                    values?.gort_invoice_discount_percentage,
                  gort_pay_to_address: values?.gort_pay_to_address || null, //new
                  gort_ship_to_address: values?.gort_ship_to_address || null, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter"
                },
                itemData: values?.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_id: item?.item_id,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  // item_unit_price: parseFloat(item?.item_unit_price),
                  item_quantity: parseFloat(item?.quantity),
                  item_free_quantity: item?.item_free_quantity || 0,
                  item_received_quantity: parseFloat(item?.quantity),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_pack_size: parseFloat(item.item_pack_size),
                  item_tax_amount: item?.item_tax_amount || 0,
                  item_discount_amount: item?.item_discount_amount || 0,
                  item_gst: item?.item_gst,
                  item_cgst: values?.is_inter_state===false?(item?.item_cgst):0,
                  item_sgst: values?.is_inter_state===false?(item?.item_sgst):0,
                  item_igst: values?.is_inter_state===true?(item?.item_igst):0,
                  ...(item?.pot_id && type === "order"
                    ? { pot_id: item?.pot_id }
                    : { pot_id: null }),
                  ...(item?.prt_id && type === "return"
                    ? { prt_id: item?.prt_id }
                    : { prt_id: null }),
                  base_ref_id: item?.base_ref_id ?? null,
                  base_ref_type: item?.base_ref_type ?? null,
                  base_ref_line_id: item?.base_ref_line_id ?? null,
                  base_ref_doc_number: item?.base_ref_doc_number ?? null,
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                })),
                itemBatchData: values.data?.slice(0, -1).flatMap((item) =>
                  item.item_batches.map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_sellable_quantity: parseFloat(
                      batch?.item_sellable_quantity
                    ),
                    item_batch_free_quantity:
                      parseFloat(batch?.item_batch_free_quantity) || 0,

                    item_batch_total_effective_qauntity:
                      parseInt(batch?.item_batch_total_effective_qauntity) || 0, //new
                    item_batch_purchase_rate: Number(batch?.item_batch_purchase_rate) || 0,

                    item_batch_total_base_purchase_rate:
                      parseFloat(batch?.item_batch_total_base_purchase_rate) ||
                      0, //new

                    item_batch_for_qauntity:
                      parseInt(batch?.item_batch_for_qauntity) || 0, //new
                    item_batch_for_free_qauntity:
                      parseInt(batch?.item_batch_for_free_qauntity) || 0, //new
                    item_batch_scheme_discount_percentage:
                      parseFloat(
                        batch?.item_batch_scheme_discount_percentage
                      ) || 0, //new
                    item_batch_scheme_discount_amount:
                      parseFloat(batch?.item_batch_scheme_discount_amount) || 0, //new

                    item_batch_scheme_purchase_rate:
                      parseFloat(batch?.item_batch_scheme_purchase_rate) || 0, //new
                    item_batch_ptr_amount:
                      parseFloat(batch?.item_batch_ptr_amount) || 0,
                    item_batch_pts_amount:
                      parseFloat(batch?.item_batch_pts) || 0,
                    item_batch_discount_percentage:
                      parseFloat(batch?.item_batch_discount_percentage) || 0, //new
                    item_batch_gen_discount_amount:
                      parseFloat(batch?.item_batch_gen_discount_amount) || 0, //new
                    item_batch_discounted_purchase_rate:
                      parseFloat(batch?.item_batch_discounted_purchase_rate) ||
                      0, //new
                    item_batch_taxable_amount:
                      batch?.item_batch_taxable_amount || 0,
                    item_batch_purhcase_rate_before_tax:
                      batch?.item_batch_purhcase_rate_before_tax || 0,
                    item_batch_total_purchase_rate:
                      Number(batch?.item_batch_total_purchase_rate) || 0,
                    item_batch_discount_amount:
                      Number(batch?.item_batch_discount_amount) || 0,
                    item_batch_tax_percentage:
                      Number(batch?.item_batch_tax_percentage) || 0,
                    item_batch_tax_amount: Number(batch?.item_batch_tax_amount) || 0,
                    item_batch_final_purchase_rate:
                      Number(batch?.item_batch_final_purchase_rate) || 0,
                    item_batch_total_purchase_rate:
                      Number(batch?.item_batch_total_purchase_rate) || 0,
                    item_batch_margin_percentage:
                      Number(batch?.item_batch_margin_percentage) || 0,
                    item_batch_unit_price: Number(batch?.item_batch_unit_price) || 0,
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    to_bin_location: batch?.to_bin_location,
                    from_bin_id: batch?.from_bin_id,
                    to_bin_id: batch?.to_bin_id,
                    item_uom_id: item?.item_uom_id ?? "",
                    item_uom: item?.item_uom ?? "",
                    item_batch_cgst_percentage:values?.is_inter_state===false?(batch?.item_batch_cgst_percentage||0):0,
                    item_batch_sgst_percentage:values?.is_inter_state===false?(batch?.item_batch_sgst_percentage||0):0,
                    item_batch_igst_percentage:values?.is_inter_state===true?(batch?.item_batch_igst_percentage||0):0,
                    item_batch_cgst_amount:values?.is_inter_state===false?(batch?.item_batch_cgst_amount||0):0,
                    item_batch_sgst_amount:values?.is_inter_state===false?(batch?.item_batch_sgst_amount||0):0,
                    item_batch_igst_amount:values?.is_inter_state===true?(batch?.item_batch_igst_amount||0):0,
                  }))
                ),
                creditNoteData: (values?.creditNoteData || [])
                  .filter((note) => note?.isChecked)
                  .map((note) => ({
                    invoice_number: note?.invoice_number ?? "",
                    invoice_total_amount:
                      parseFloat(note?.invoice_total_amount) || 0,
                    remaining_amount: parseFloat(note?.remaining_amount) || 0,
                    adjusted_amount: parseFloat(note?.adjusted_amount) || 0,
                    claimed_amount: parseFloat(note?.claimed_amount) || 0,
                    invoice_date: note?.invoice_date ?? "",
                    remarks: note?.remarks ?? "",
                  })),
              },
              (data) => {
                successToast(data?.message);
                // setLoading(true);
                setTimeout(() => {
                  // setLoading(false);
                }, 50);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-goods/${data?.data?.orderData?.[0]?.gort_id}?new`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                errorToast(data?.data?.message);
              }
            )
          );
        }
      }
    }
  };
  return (
    <>
      <BulkGrnModal
        setLoading={setLoading}
        disabled={disabled}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setOrderDetail={setOrderDetail}
      />
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          if (submitScheduledRef.current || isDispatchingRef.current) {
            actions.setSubmitting(false);
            return;
          }
          submitScheduledRef.current = true;
          setButtonLoading(true);
          setTimeout(() => {
            submitScheduledRef.current = false;
            handleBilling(values, actions); // arms isDispatchingRef on dispatch
            if (!isDispatchingRef.current) {
              setButtonLoading(false);
            }
            actions.setSubmitting(false); // Notify Formik that submission is done
          }, 500);
        }}
      >
        {({ values }) => {
          setFormValues(values);
          formValuesRef.current = values; // Store latest values persistently
          return (
            <Form className="h-full">
              <PurchaseBatchesPanel
                searchRef={searchRef}
                open={addbatch}
                disabled={disabled}
                binLocationList={binLocationList}
                setItemId={setItemId}
                itemId={itemId}
                setOpen={setAddbatch}
                itemValues={values}
              />
              <GrnCsvImport
                tempalteArray={initUploadDocumentsGrn.map(
                  ({ documentType, expectedHeaders }) => ({
                    documentType,
                    expectedHeaders,
                  })
                )}
                handleFileUpload={(e) => {
                  if (values?.cmr_id) {
                    handleFileUpload(e, values);
                  } else {
                    e.target.value = null; // This resets the file input
                    errorToast("Please select Vendor");
                  }
                }}
                setIsModalOpen={setIsModalOpen}
                isModalOpen={isModalOpen}
                setGrnCsvImportOpen={setGrnCsvImportOpen}
                grnCsvImportOpen={grnCsvImportOpen}
              />

              <PurchaseCreditNotePanel
                page={page}
                open={creditNotesOpen}
                setOpen={setCreditNotesOpen}
              />

              <div
                style={{
                  height: `calc(100% - 8rem)`,
                }}
                className="mx-5 flex flex-col h-full "
              >
                <SalesPurchaseNavbar
                  isClone={isClone}
                  autoDraft={autoDraft}
                  clickedplus={clickedplus}
                  pageType={pageType}
                  page={page}
                  csvTemLoading={csvTemLoading}
                  csvButtonText="Import Vendor CSV"
                  handleFileUpload={(e, type) => {
                    setGrnCsvImportOpen(true);
                  }}
                  importcsv={true}
                  section="purchase"
                  name="gort"
                  disabled={disabled}
                  searchRef={searchRef}
                  tempalteArray={initUploadDocumentsGrn.map(
                    ({ documentType, expectedHeaders }) => ({
                      documentType,
                      expectedHeaders,
                    })
                  )}
                  fetchCreditNoteFn={() => {
                    setCreditNotesOpen(true);
                  }}
                  storeDetails={storeDetails}
                  transfer={transfer}
                  standAlone={!transfer}
                />
                <PurchaseItemsSection
                  heading={heading}
                  prefixName="gort"
                  disabled={values.is_inter_state===null || disabled}
                  addBatchFn={(id) => {
                    setAddbatch(true);
                    setItemId(id);
                  }}
                  searchRef={searchRef}
                  initialData={initialData}
                />
              </div>

              <SalesPurchaseFooter
                EditFn={() => {
                  navigate(`/edit-goods/${values?.gort_id}`);
                }}
                formValuesRef={formValuesRef}
                transaction="Goods Receipt"
                transaction_type="goods_receipt_note"
                buttonLoading={buttonLoading}
                name="gort_total_discount"
                page={page}
                disabled={disabled}
                prefixName="gort"
                tcsTdsAmount={tcsTdsAmount}
                setTcsTdsAmount={setTcsTdsAmount}
                handleBilling={handleBilling}
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewGrn;

export const initUploadDocumentsGrn = [
  {
    index: 0,
    documentType: "Order-Data",
    filename: "",
    expectedHeaders: [
      "cmr_id",
      "cmr_code",
      "cmr_name",
      "gort_order_date",
      "gort_document_date",
      "gort_delivery_date",
      "gort_total_gst",
      "gort_total_discount",
      "gort_total_amount",
      "remarks",
      "gort_sub_total",
    ],
  },
  {
    index: 1,
    documentType: "Item-Data",
    filename: "",
    expectedHeaders: ["item_code", "item_name", "item_hsn", "item_uom"],
  },
  {
    index: 2,
    documentType: "Batch-Data",
    filename: "",
    expectedHeaders: [
      "item_code",
      "item_batch_number",
      "item_exp_date",
      "item_batch_purchase_rate",
      "item_batch_total_base_purchase_rate",
      "item_sellable_quantity",
      "item_batch_free_quantity",
      "item_batch_total_effective_qauntity",
      "item_batch_for_qauntity",
      "item_batch_for_free_qauntity",
      "item_batch_scheme_discount_percentage",
      "item_batch_scheme_discount_amount",
      "item_batch_scheme_purchase_rate",
      "item_batch_discount_percentage",
      "item_batch_gen_discount_amount",
      "item_batch_discounted_purchase_rate",
      "item_batch_discount_amount",
      "item_batch_taxable_amount",
      "item_batch_ptr_amount",
      "item_batch_pts_amount",
      "item_batch_tax_percentage",
      "item_batch_tax_amount",
      "item_batch_final_purchase_rate",
      "item_batch_unit_price",
      "item_batch_margin_percentage",
      "item_batch_total_purchase_rate",
      "item_uom",
      "to_bin_location",
      "to_bin_id",
      "item_batch_purhcase_rate_before_tax"
    ],
  },
];
